import {
  GET_BOARD_DOCUMENTS,
  GET_BOARD_TASK_MAIN_DOCUMENTS,
  GET_DOCUMENT_CATEGORIES,
} from "./DocumentationType";

export const DocumentationReducer = (
  state = {
    Categories: [],
    Documents: [],
    TasksDocs: [],
  },
  action
) => {
  switch (action.type) {
    case GET_DOCUMENT_CATEGORIES: {
      return {
        ...state,
        Categories: action.Payload,
      };
    }
    case GET_BOARD_DOCUMENTS: {
      return {
        ...state,
        Documents: action.Payload,
      };
    }
    case GET_BOARD_TASK_MAIN_DOCUMENTS: {
      return {
        ...state,
        TasksDocs: action.Payload,
      };
    }
    default:
      return state;
  }
};
